import React from 'react';
import {
    AbstractMapView,
    AbstractMapViewProps,
    DEFAULT_FLIGHT_MAP_OPTIONS,
} from 'app/components/dashboard/network/AbstractMapView';
import { IMapProps } from 'app/components/map/CoreMap';
import MapUtils from 'app/components/map/util/MapUtils';
import { FlightAndModelType } from 'app/components/map/model/MapModel';
import { UnityApplication } from 'app/unity/UnityApplication';

//TODO omit not required props
interface MapPanelMapViewProps extends AbstractMapViewProps {
    onMapIdGenerated?: (mapId: number) => void;
    selectedFlight?: FlightAndModelType;
}

export default class MapPanelMapView extends AbstractMapView<MapPanelMapViewProps> {
    getExtraCoreMapProperties(): Partial<IMapProps> {
        return {
            onMapIdGenerated: this.props.onMapIdGenerated,
            mapLayersEnabled: true,
        } as Partial<IMapProps>;
    }

    showVpd = () => {
        return false;
    }; //it's already being displayed by the parent (solver panel) and not required for the others

    forceMapRender() {
        // this.coreMapRef.current?.forceMapRender();
    }

    renderMap() {
        const customControls = <div style={{ zIndex: 1, margin: '5px' }}>{this.renderConvectionLegend()}</div>;

        // NOTE(bjarne): In mapless mode the UnityApplication is already created in App.tsx.
        return this.nmui4dContext?.isMapless ? (
            customControls
        ) : (
            <UnityApplication customControls={customControls}></UnityApplication>
        );
    }
}
